import { contentChildren, Directive, effect, input, model, output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SortDirection, SortEvent } from '../../models/sort';
import { TableSortDirective } from './table-sort.directive';

@UntilDestroy()
@Directive({
  exportAs: 'mbsTableSortGroup',
  selector: '[mbsTableSortGroup]'
})
export class TableSortGroupDirective {
  mbsTableSortGroup = input<SortEvent>(null);
  rotateSequence = model<{ [key: string]: SortDirection }>(null);
  sort = output<SortEvent>();
  sortHeaders = contentChildren(TableSortDirective, { descendants: true, read: TableSortDirective });

  constructor() {
    effect(() => {
      const orderBy = this.mbsTableSortGroup();

      this.resetSortArrow(orderBy);
    });

    effect(() => {
      const sortHeaders = this.sortHeaders();

      sortHeaders?.forEach((header) => {
        header.rotateSequence = this.rotateSequence() || header.rotateSequence;
        !header.sort.observed && header.sort.pipe(untilDestroyed(this)).subscribe((event: SortEvent) => this.sort.emit(event));
      });
      this.resetSortArrow(this.mbsTableSortGroup());
    });
  }

  private resetSortArrow(orderBy: SortEvent): void {
    this.sortHeaders()?.forEach((header) => {
      if (!orderBy || orderBy.column !== header.columnName) {
        header.changeState('');
      } else {
        header.changeState(orderBy.direction);
      }
    });
  }
}
